import type { DeckardIcon, DeckardIconProps } from '@assets/icons';
import { Tooltip, type TooltipProps } from '@components/tooltip';
import { Box, useTheme } from '@mui/material';
import { IconButton } from './IconButton';

export const ActionButton = ({
  Icon,
  iconProps,
  label,
  labelProps,
  onClick,
  disabled,
}: {
  Icon: DeckardIcon;
  iconProps?: DeckardIconProps;
  label: string;
  labelProps?: Partial<TooltipProps>;
  onClick: VoidFunction;
  disabled?: boolean;
}) => {
  const { palette } = useTheme();
  const handleClick = () => {
    if (!disabled) {
      onClick();
    }
  };
  return (
    <Box
      sx={{
        display: 'flex',
        cursor: disabled ? 'default' : 'pointer',
        justifyContent: 'center',
        alignItems: 'center',
        flexDirection: 'column',
        gap: 1,
        '&:hover': {
          ...(disabled
            ? {}
            : {
                '& .deckard-icon': {
                  stroke: `${palette.text.contrast} !important`,
                },
                '& .MuiTypography-root': {
                  color: palette.text.contrast,
                },
              }),
        },
      }}
      onClick={handleClick}
    >
      <Tooltip title={label} {...labelProps}>
        <span>
          <IconButton Icon={Icon} size={22} disabled={disabled} iconProps={iconProps} />
        </span>
      </Tooltip>
    </Box>
  );
};
